export function parseHTML(html: string) {
  const t: any = document.createElement('template');
  t.innerHTML = html;
  return t.content;
}
